import PropTypes from 'prop-types';

const defaultProps = {
	color: '#fff',
	size: 22,
};

const propTypes = {
	color: PropTypes.string,
	loading: PropTypes.bool.isRequired,
	size: PropTypes.number,
};

const LoadingIcon = ({
	color,
	loading,
	size,
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 100 100"
		preserveAspectRatio="xMidYMid"
	>
		<g transform="rotate(360 50 50)">
			<path
				d="M50 15A35 35 0 1 0 74.787 25.213"
				fill="none"
				stroke={color}
				strokeWidth="10"
			/>
			<path
				d="M49 3L49 27L61 15L49 3"
				fill={color}
			/>
			{loading && (
				<animateTransform
					attributeName="transform"
					type="rotate"
					calcMode="linear"
					values="0 50 50;360 50 50"
					keyTimes="0;1"
					dur="1.5s"
					begin="0s"
					repeatCount="indefinite"
				/>
			)}
		</g>
	</svg>
);

LoadingIcon.defaultProps = defaultProps;
LoadingIcon.propTypes = propTypes;

export default LoadingIcon;
